import { STATUS_TYPE } from '../../../enum';

export interface GetBundleSubcategory {
  id: string;
}

export interface FindBundleSubcategory {
  search?: string;
  bundleCategoryId?: string;
  activeState?: boolean;
  limit?: number;
  skip?: number;
}

export interface CreatePatchBundleSubcategory {
  id?: string;
  bundleCategoryId: string;
  labelEn: string;
  labelAr: string;
  imgUrl?: string | null;
  position: string | number;
  activeState: boolean;
}

export interface BundleSubcategory {
  id: string;
  bundleCategoryId: string;
  labelEn: string;
  labelAr: string;
  imgUrl?: string | null;
  position: string | number;
  activeState: boolean;
  productCount?: number;
  bundle_category?: {
    id: string;
    labelEn: string;
    labelAr: string;
  };
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: BundleSubcategory[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
